import * as _ from 'lodash';

export function resolveUserLocale() {
  const browserLanguagePropertyKeys = [ 'languages', 'language', 'browserLanguage', 'userLanguage', 'systemLanguage' ];

  let detectedLocale = _.first(_.chain(window.navigator)
    .pick(browserLanguagePropertyKeys)
    .values()
    .flatten()
    .compact()
    .value());

  return detectedLocale;
}
